import { useTranslation } from "react-i18next";
import BlurRevealText from "./BlurRevealText";
import { CapabilityIcon } from "./PlatformCapabilities";

// Order matches platformPillars.items in the locale files.
const pillarIconTypes = [
  "provisioning",
  "api",
  "whitelabel",
  "coverage",
  "partners",
];

function PlatformPillars() {
  const { t } = useTranslation();
  const pillars = t("platformPillars.items", { returnObjects: true });

  return (
    <section className="platform-pillars-section py-50">
      <div className="container">
        <div className="platform-pillars-head">
          <p className="banner-sub-heading p-2">
            {t("platformPillars.overline")}
          </p>
          <BlurRevealText
            as="h2"
            className="platform-pillars-title"
            lines={t("platformPillars.titleLines", { returnObjects: true })}
          />
          <p className="platform-pillars-subtitle">
            {t("platformPillars.subtitle")}
          </p>
        </div>

        <div className="platform-pillars-grid">
          {pillars.map((item, index) => (
            <article className="platform-capability-card" key={item.title}>
              <span className="platform-capability-icon">
                <CapabilityIcon type={pillarIconTypes[index]} />
              </span>
              <div>
                <h3 className="platform-capability-title">{item.title}</h3>
                <p className="platform-capability-text">{item.description}</p>
              </div>
            </article>
          ))}
        </div>

        <p className="platform-pillars-note">{t("platformPillars.consumerNote")}</p>
      </div>
    </section>
  );
}

export default PlatformPillars;
